import React from 'react';
import Contents from '../components/Content/Contents';
 const Content = () => {
    return ( <Contents/> );
 }
  
 export default Content;